/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { OverviewViewStatEnum } from './overview-view-stat-enum'
import { BetSizeEnum } from './bet-size-enum'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OverviewViewStatSchemaStatType = { ...OverviewViewStatEnum, ...BetSizeEnum } as const
